import * as React from 'react';
import {cn} from 'src/lib/utils';

type Props = {
  icon?: React.ReactNode;
  children: React.ReactNode;
  containerProps?: React.ComponentPropsWithRef<'div'>;
};

const IconBadge = (props: Props) => {
  const {className, ...restContainerProps} = props.containerProps ?? {};
  return (
    <div
      className={cn(
        'relative flex min-w-0 flex-row items-center text-sm',
        className,
      )}
      {...restContainerProps}
    >
      <div className="mr-2 h-4 w-4 min-w-4 flex-none align-middle">
        {props.icon}
      </div>
      <div className="min-w-0 flex-grow">{props.children}</div>
    </div>
  );
};

export default IconBadge;
